<template>
  <div v-if="salary !== null"
       class="vacancy-salary">
    {{ salary }}
    <span>
      {{ currentCurrency }}<template v-if="salaryPerType">/</template>{{ salaryPerType }}
    </span>
    <sub
      v-if="salaryBrutto"
      class="_gross"
    >
      {{ $tVacancy('gross') }}
    </sub>
    <sub v-else>{{ $tVacancy('net') }}</sub>

    <BaseTooltip
      :text="salaryBruttoNetDescription"
      class="vacancy-salary__gross-tooltip"
      tooltip-menu-style="max-width: 20rem"
    >
      <template v-slot:activator>
        <div class="vacancy-salary__tooltip-activator">
          ?
        </div>
      </template>
    </BaseTooltip>
  </div>
</template>

<script>
  import formatNumber from '@/helpers/formatNumber'

  export default {
    name: 'VacancyCardSmallSalary',
    props: {
      vacancy: Object
    },
    computed: {
      salary() {
        const salary = this.vacancy[1].salary_in_selected_currency
        return this.getSalary(salary)
      },
      salaryBrutto() {
        return this.vacancy[1].salary_brutto;
      },
      salaryBruttoNetDescription() {
        return this.salaryBrutto
          ? this.$tVacancy('salary_gross_description')
          : this.$tVacancy('salary_net_description');
      },

      salaryPerType() {
        const type = this.vacancy[1].salary_type
        return type ? type.name : null
      },

      currentCurrency() {
        let currentCurrency = this.$store.state.currentCurrency
        if (currentCurrency.currency === 'ALL') {
          currentCurrency = this.vacancy[1].currency
        }

        return currentCurrency ? currentCurrency.symbol : null
      },
    },
    methods: {
      getSalary(salary) {
        if (Array.isArray(salary)) {
          if (isNaN(parseFloat(salary[0])) || isNaN(parseFloat(salary[1]))) {
            return null
          }

          return salary[0] === salary[1]
              ? formatNumber(salary[0])
              : `${formatNumber(salary[0])} - ${formatNumber(salary[1])}`
        }

        return isNaN(parseFloat(salary)) ? null : formatNumber(salary)
      }
    }
  }
</script>

<style lang="less">

</style>
